export const gitCommit = 'e6201cfc'
